import React from "react";

import { Step, StepConnector, StepLabel, useMediaQuery } from "@material-ui/core";
import MuiStepper from "@material-ui/core/Stepper";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Check from "@material-ui/icons/Check";

const QontoConnector = withStyles((theme) => ({
  active: {
    "& $line": {
      borderColor: theme.palette.primary.main,
    },
  },
  completed: {
    "& $line": {
      borderColor: theme.palette.primary.main,
    },
  },
  line: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}))(StepConnector);

const useStyles = makeStyles((theme) => {
  return {
    root: {
      backgroundColor: "#E9EBEC80",

      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
        overflowX: "auto",
        overflowY: "hidden",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",

        "&::-webkit-scrollbar": {
          display: "none",
        },

        "& .MuiStep-root": {
          flex: "0 0 auto",
          minWidth: 140,
        },
      },
    },

    step: {
      "& .MuiStepLabel-root": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyItems: "center",
      },

      "& .MuiStepLabel-root.Mui-disabled": {
        "& .MuiStepLabel-iconContainer": {
          backgroundColor: theme.palette.gray[400],
          "& svg": {
            fill: theme.palette.gray[700],
          },
        },
      },

      "& .MuiStepLabel-iconContainer": {
        height: "24px",
        width: "24px",
        borderRadius: "50%",
        padding: "14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.primary.main,

        "& svg": {
          fill: theme.palette.background.default,
          width: "14px",
          height: "14px",
        },
      },

      "& .MuiStepLabel-labelContainer": {
        "& > span": {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyItems: "center",
          fontWeight: 700,
          fontSize: "16px",
        },

        "& small": {
          fontSize: "12px",
          fontWeight: 400,
        },
      },

      [theme.breakpoints.down("sm")]: {
        "& .MuiStepLabel-iconContainer": {
          height: "20px",
          width: "20px",
          padding: "10px",

          "& svg": {
            width: "12px",
            height: "12px",
          },
        },

        "& .MuiStepLabel-labelContainer": {
          "& > span": {
            fontSize: "14px",
            lineHeight: 1.2,
            whiteSpace: "normal",
            textAlign: "center",
            maxWidth: 140,
          },

          "& small": {
            fontSize: "11px",
            lineHeight: 1.2,
          },
        },
      },
    },
  };
});

export default function Stepper({ children, steps, activeStep, showIndex = false, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <React.Fragment>
      <MuiStepper
        className={classes.root}
        alternativeLabel
        activeStep={activeStep}
        connector={<QontoConnector />}
        style={isSmDown ? { justifyContent: "flex-start" } : undefined}
        {...props}
      >
        {steps.map(({ title, subtitle }, key) => (
          <Step className={classes.step} key={key}>
            <StepLabel className={classes.stepLabel} StepIconComponent={Check}>
              {showIndex && key + 1}. {title}
              <small>{subtitle}</small>
            </StepLabel>
          </Step>
        ))}
      </MuiStepper>

      {children && children(activeStep)}
    </React.Fragment>
  );
}
